import { useTranslation } from "react-i18next";
import { Grid, Row, Col } from "rsuite";
import ShortCutPanel, { types } from "../components/ShortcutPanel";
import NoticeIcon from "@rsuite/icons/Notice";
import BellO from "@rsuite/icons/legacy/BellO";

const AlarmsShortcuts = () => {
  const [t] = useTranslation();

  return (
    <Grid fluid>
      <Row>
        <Col xs={24} sm={24} lg={12}>
          <ShortCutPanel
            type={types.error}
            title={t("main-sidebar.global-alarms")}
            paragraph={t("main-sidebar.alarms")}
            href={"#"}
            icon={<NoticeIcon />}
            className={"content-init"}
          />
        </Col>
        <Col xs={24} sm={24} lg={12}>
          <ShortCutPanel
            type={types.error}
            title={t("main-sidebar.individual-alarms")}
            paragraph={t("main-sidebar.alarms")}
            href={"/alarms/individual"}
            icon={<BellO />}
            className={"content-end"}
          />
        </Col>
      </Row>
    </Grid>
  );
};

export default AlarmsShortcuts;
